import { gql } from "lib/apolloClient";
import { attachmentFragment } from "modules/CommonFragments";

export const modalitiesFragments = {
  modalityAttachment: gql`
    fragment modalityAttachmentItem on ModalityAttachmentInterface {
      id
      ... on ToddleDoc {
        id
        content: value
      }
      ... on ModalityFile {
        id
        content
        metadata
      }
    }
  `,
};

export const attachmentWithModalityFragment = gql`
  fragment attachmentWithModalityItem on Attachment {
    ...attachmentItem
    modalityAttachment {
      ...modalityAttachmentItem
    }
  }
  ${attachmentFragment.attachment}
  ${modalitiesFragments.modalityAttachment}
`;
